import { render } from "./LoadingPage.vue?vue&type=template&id=6701b7e0"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=6701b7e0&lang=scss"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__